import store from '@/store';
import { onError } from '@apollo/client/link/error';
import { captureException } from '@sentry/vue';
import getErrorByCode from '@utils/getErrorByCode';

const showLoginExpiredModal = () => {
  if (store.state.user.loggedIn) {
    store.dispatch('modal/show', {
      type: 'LoginExpiredCard',
      stackable: true,
    });
  }
};

export const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    // @ts-expect-error error is a custom property
    if (networkError.error && networkError.error === 'login_required') {
      // Auth0 login is expired and could not be refreshed
      showLoginExpiredModal();
    } else if ('statusCode' in networkError && networkError.statusCode) {
      switch (networkError.statusCode) {
        case 401:
          // auth0 login could not be verified on server
          showLoginExpiredModal();
          break;
        default:
      }
    } else if (networkError.message) {
      switch (networkError.message) {
        case 'NetworkError when attempting to fetch resource.':
          // FIXME: This will also show if you reload the page when a requesr is made, but
          // it should only show in case of a hard server error
          // store.dispatch('notification/show', { message: i18n.global.t('notification.serverError') }, { root: true });
          break;
        default:
      }
    }
  } else if (graphQLErrors && graphQLErrors.length) {
    if (graphQLErrors[0].message === 'User does not exist.' && store.state.user.loggedIn) {
      // This happens when the logged in user has been deleted on the server
      store.dispatch('user/revoke');
    } else {
      const noAccess = getErrorByCode({ graphQLErrors }, 'NO_ACCESS');

      if (noAccess && store.state.user.loggedIn) {
        switch (noAccess.extensions.reason) {
          case 'LIMITED_VERSION':
            store.dispatch('modal/show', {
              type: 'LimitedVersionCard',
              stackable: true,
              payload: {
                canHaveTrial: store.state.user.canHaveTrial,
              },
            });
            break;
          case 'LICENSE_UNVERIFIED':
            store.dispatch('modal/show', {
              type: 'LicenseUnverifiedCard',
              stackable: true,
            });
            break;
          default:
            break;
        }
      }

      const inputError = getErrorByCode({ graphQLErrors }, 'BAD_USER_INPUT');

      if (inputError) {
        captureException(inputError);
      }
    }
  }
});
